@let form = block();
<div [formGroup]="form" class="flex flex-col gap-6 py-4">
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-[12rem_minmax(0,1fr)]">
    <div class="text-standard-text-secondary pl-8 text-sm font-semibold">
      {{ cmsTextProvider.footer.type }}
    </div>
    <div class="w-80">
      <aw-drop-down
        [id]="'footer-block-type-' + index()"
        [formControl]="form.controls.type"
        name="name"
        valueAttribute="value"
        [options]="footerBlockTypeOptions"></aw-drop-down>
    </div>
  </div>

  @let blockType =
    (form.controls.type.valueChanges | async) ?? form.controls.type.value;
  @if (blockType !== FooterBlockType.Default) {
    <div class="grid grid-cols-1 gap-4 lg:grid-cols-[12rem_minmax(0,1fr)]">
      <div class="text-standard-text-secondary pl-8 text-sm font-semibold">
        {{ cmsTextProvider.shared.title }}
      </div>
      <div class="flex items-center gap-6">
        <div class="w-80">
          <aw-translation-text-input
            [entityType]="EntityType.footerLinkArea"
            [relationType]="TextRelationType.headline"
            [id]="'block-title-' + index()"
            [formControl]="form.controls.headlines"
            [label]="''"></aw-translation-text-input>
        </div>
        <aw-checkbox
          [formControl]="form.controls.isActive"
          [label]="cmsTextProvider.shared.show"
          [id]="'block-active-' + index()"></aw-checkbox>
      </div>
    </div>
  }

  @switch (blockType) {
    @case (FooterBlockType.Text) {
      <aw-footer-text-block-editor [block]="form" [index]="index()" />
    }
    @case (FooterBlockType.Links) {
      <aw-footer-links-block-editor [block]="form" [index]="index()" />
    }
    @case (FooterBlockType.Logo) {
      <aw-footer-logo-block-editor [block]="form" [index]="index()" />
    }
    @case (FooterBlockType.Payments) {
      <aw-footer-payments-block-editor [block]="form" [index]="index()" />
    }
    @case (FooterBlockType.Images) {
      <aw-footer-images-block-editor [block]="form" [index]="index()" />
    }
  }
</div>
